import { render, staticRenderFns } from "./3DViewer.vue?vue&type=template&id=d19a4542&scoped=true"
import script from "./3DViewer.vue?vue&type=script&lang=js"
export * from "./3DViewer.vue?vue&type=script&lang=js"
import style0 from "./3DViewer.vue?vue&type=style&index=0&id=d19a4542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19a4542",
  null
  
)

export default component.exports